export default __webpack_public_path__ + "static/media/bundle-kit.fe2790d6.jpg";